import React, { useState, useRef, useEffect } from 'react';

const renderOption = (opt, idx, closeMenu, depth = 0) => {
  const items = [];
  const paddingClass = depth === 0 ? 'pl-4' : depth === 1 ? 'pl-8' : 'pl-12';

  items.push(
    <div
      key={`${opt.label}-${idx}`}
      className={`${paddingClass} pr-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap`}
      onClick={() => {
        closeMenu();
        opt.onClick?.();
      }}
    >
      {opt.label}
    </div>
  );

  if (Array.isArray(opt.children) && opt.children.length > 0) {
    opt.children.forEach((child, childIdx) => {
      items.push(...renderOption(child, `${idx}-${childIdx}`, closeMenu, depth + 1));
    });
  }

  return items;
};

const SplitButton = ({ mainLabel, options, className = '', onMainClick }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`relative inline-block ${className}`} ref={ref}>
      <button
        type="button"
        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-1 px-2 rounded-l"
        onClick={() => onMainClick?.()}
      >
        {mainLabel}
      </button>
      <button
        type="button"
        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-1 px-2 rounded-r border-l border-gray-400"
        onClick={() => setOpen((current) => !current)}
      >
        ▼
      </button>
      {open && (
        <div className="absolute z-10 left-0 mt-1 min-w-48 rounded border border-gray-300 bg-white shadow-lg">
          {options.flatMap((opt, idx) => renderOption(opt, idx, () => setOpen(false)))}
        </div>
      )}
    </div>
  );
};

export default SplitButton;
